// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2CE8p","container":"styles_container__34Gkh","title":"styles_title__OF0V4","wrapper":"styles_wrapper__2uV51","answer":"styles_answer__IKm-i"};